import React from 'react';
import { formatMoney, Tooltip } from '../../utils';
import { openDocument } from '@taktikal/fillandsign'


const textA = "Fjárhæð laus til útgreiðslu er uppsagnarvirði samnings miðað við 1.4.2021 að frádregnum 500 EUR á samningum sem hafa upphafsdag  31.12.2018 eða síðar, en 1000 EUR á eldri samningum,  sem skilja þarf eftir til að halda samningum virkum."
const textB = " Úttektarfjárhæðinni er skipt í krónur á gengi þess dags þegar hún berst frá Þýskalandi. Upphæðir í íslenskum krónum eru háðar gengi og því eingöngu ætlaðar til viðmiðunar."

class CovidModal extends React.Component {

    constructor(props) {
        super(props)
        this.state = { }
    }


    signDocument() {
        openDocument("321cb33b5883", { smartForm: true })
    }

    render() {
        return (
            <div className="modal covid" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel"
                aria-hidden="true" id={this.props.modalId}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <img src={window.images.logo} />
                            <button type="button" className="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                        </div>

                        <div className="modal-body">
                            { parseInt(this.props.contract.Contract.RepurchaseCovidAmountCur) > 0 ?
                                <>
                                    <div>
                                        <strong>Fjárhæð laus til útgreiðslu: </strong>
                                        <span>{formatMoney(this.props.contract.Contract.RepurchaseCovidAmountCur)} € <Tooltip text={textA} /> </span>
                                    </div>
                                    <div className="xs-mb-40">
                                        <strong>Fjárhæð laus til útgreiðslu: </strong>
                                        <span>{formatMoney(this.props.contract.Contract.RepurchaseCovidAmountCur * this.props.contract.Contract.CurrencyRate)} kr.<sup>*</sup> <Tooltip text={textB} /> </span>
                                    </div>

                                    <strong>
                                    Athugið að fjárhæðir eru birtar með fyrirvara.
                                    </strong>
                                    <p>Hafi verið sótt um áður um útgreiðslu vegna Covid er möguleiki að ekki sé búið að uppreikna stöðu samnings.</p>
                                    <p>Við vekjum athygli á því að heildarfjárhæð, hjá Allianz og öðrum vörsluaðilum, sem einstaklingur má taka út af séreignarsparnaði sínum er 12 milljónir króna</p>
                                    <p><strong>Tekjuskattur er greiddur af úttekt:</strong></p>
                                    <ul>
                                        <li>31,45% af tekjum 0 - 349.018 kr.</li>
                                        <li>37,95% af tekjum 349.019 - 979.847 kr.</li>
                                        <li>46,25% af tekjum yfir 979.847</li>
                                    </ul>
                                    <p>Umsóknir sem berast fyrir 10. hvers mánaðar koma til útgreiðslu 20. næsta mánaðar. Dæmi: Umsókn berst fyrir 10. maí kemur til greiðslu 20. júní.</p>

                                    <div className="col-12 xs-mt-20 xs-mb-20">
                                        <button className="btn btn-primary" onClick={this.signDocument}>
                                            Úttekt (rafræn umsókn) 
                                        </button>
                                    </div>

                                    <p className="small"><em><sup>* </sup> Miðað við gengi dagsins í dag ({formatMoney(this.props.contract.Contract.CurrencyRate, 2)} kr).<br />
                                    Úttektarfjárhæðinni er skipt í krónur á gengi þess dags þegar hún berst frá Þýskalandi. Upphæðir í íslenskum krónum eru háðar gengi og því eingöngu ætlaðar til viðmiðunar.</em></p>
                                </>
                            :
                                <>
                                    <p><strong>Engin inneign er laus til úttektar.</strong></p>
                                    <p>Einungis er heimilt að taka út inneign sem var laus til útborgunar 1.4.2021 að frádregnum 500€ á samningum sem hafa upphafsdaginn 31.12.2018 eða síðar, en 1000€ á eldri samningum, sem skilja þarf eftir til að halda samningum virkum. </p>
                                    <p>Teljir þú að um mistök séu að ræða eða ef frekari upplýsinga er óskað bendum við þér á að senda tölvupóst á <a href="mailto:utborgun@allianz.is">utborgun@allianz.is</a></p>
                                    <img src={window.images.myPagesEmpty} />
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

CovidModal.defaultProps = { }
export default CovidModal;